import React from 'react';
import { Avatar } from 'antd';
import { clsx } from 'clsx';

export const UserAvatar = ({
  initials,
  textAsInitials,
  size = 40,
  textColor,
  backgroundColor,
  borderColor,
  onClick,
  style,
  uppercase,
  ...props
}: {
  initials?: string;
  textAsInitials?: string;
  size?: number;
  textColor?: string;
  backgroundColor?: string;
  /** Draws a 1px solid ring in this color around the avatar. */
  borderColor?: string;
  onClick?: () => void;
  uppercase?: boolean;
  style?: { [key: string]: unknown };
}) => (
  <>
    <div
      onClick={onClick}
      className={clsx('wk-user-avatar', !!onClick && 'click-enabled')}
    >
      <Avatar
        shape="circle"
        size={size}
        className="avatar"
        style={{
          ...style,
          textTransform: uppercase ? 'uppercase' : 'lowercase',
          backgroundColor: backgroundColor,
          color: textColor,
          fontSize: `${size / 2.5}px`,
          ...(borderColor ? { border: `1px solid ${borderColor}` } : {}),
        }}
        {...props}
      >
        {initials || extractInitials(textAsInitials || '')}
      </Avatar>
    </div>
    <style jsx>{`
      .wk-user-avatar {
        display: inline-block;
        cursor: default;
      }
      .wk-user-avatar.click-enabled {
        cursor: pointer;
      }
    `}</style>
  </>
);

function extractInitials(text: string) {
  return text
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}
